import type { StaffPermission } from "@townsy/contracts";

/**
 * The tabs of the /review page and the permission each one needs (ADR-0035). Shared by the review page, the staff hub
 * and the page header so they never disagree; the server checks the same permission on every request.
 */
export type ReviewTab = "designs" | "tasks" | "reports" | "house";

export const REVIEW_LINKS: ReadonlyArray<{ permission: StaffPermission; tab: ReviewTab; label: string; hint: string }> = [
  { permission: "creatives.review", tab: "designs", label: "Designs", hint: "store signs, boards and billboards waiting for review" },
  { permission: "campaigns.review", tab: "tasks", label: "Tasks", hint: "sponsored-task campaigns waiting for review" },
  { permission: "reports.read", tab: "reports", label: "Reports", hint: "reports about people, with their recent lines" },
  { permission: "house_campaigns.manage", tab: "house", label: "House campaigns", hint: "Townsy's own quizzes at civic buildings" },
];

/** The /review tabs these permissions open, in page order. */
export function reviewTabsFor(permissions: readonly StaffPermission[]): ReviewTab[] {
  return REVIEW_LINKS.filter((l) => permissions.includes(l.permission)).map((l) => l.tab);
}
